/** Components whose form answer is a boolean, including non-chargeable consent. */
export const isBooleanOrderComponent = (code?: string): boolean =>
  [
    'EQUIPMENT_TAGGING',
    'MEASUREMENTS',
    'TITLE_CHECK',
    'SAME_DAY',
    'WEEKEND_CONSENT',
  ].includes(code ?? '');
